export default {
	drafts: {
		findActiveDraftLinkElem: (draftPath, articleId) => {
			let $draftLinkTarget = $(
				`.j-article-iterations-menu[data-for-article-id='${articleId}'] li.active a[href='${draftPath}']`,
			);
			// Special case for the `_generic_group_workspace` with only one Article, which does not render the `_article_iterations_menu
			if (draftPath.indexOf("/edit") != -1 && !$draftLinkTarget.length) {
				$draftLinkTarget = $(
					`.j-generic-group-workspace-top-menu li.active a[href='${draftPath}'], a.j-hidden-draft-link[href='${draftPath}']`,
				);
			}
			return $draftLinkTarget; // Might still be empty
		},

		/**
		 * Make the Draft reload for whoever is still editing it right now (will not affect all recipients but that doesn't matter)
		 */
		reloadActiveDraft: (draftPath, articleId) => {
			const $draftLinkTarget =
				pp.activityFeedHelpers.drafts.findActiveDraftLinkElem(
					draftPath,
					articleId,
				);
			if ($draftLinkTarget.length) {
				$draftLinkTarget.trigger("click");
				return true;
			}
			return false;
		},

		unloadActiveUnsubmittedDraft: (draftPath, articleId) => {
			const $draftLinkTarget =
				pp.activityFeedHelpers.drafts.findActiveDraftLinkElem(
					draftPath,
					articleId,
				);
			if (
				$draftLinkTarget.length &&
				$draftLinkTarget
					.closest(".j-article-iterations-menu")
					.hasClass("active")
			) {
				Turbolinks.visit(`/articles/${articleId}`);
				return true;
			}
			return false;
		},

		replaceArticleMenuDropdownItem: (articleId, draftLinkHtml) => {
			// Will be present (but hidden) on xs viewports
			if (!$(".j-articles-menu").length) {
				return;
			}
			// Both top-right dropdown menu and subnav
			const $disabledLink = $(
				`.j-articles-menu li.disabled[data-article-id='${articleId}'], .SubNav.dropup li.disabled[data-article-id='${articleId}']`,
			);
			if (!$disabledLink.length) {
				return;
			}
			$disabledLink.replaceWith(draftLinkHtml);
		},

		appendOrReplaceIterationsDropdownItem: (articleId, draftLinkHtml) => {
			let $listElement;
			const $articleIterationsMenu = $(
				`.j-article-iterations-menu[data-for-article-id='${articleId}']`,
			).find("ul.dropdown-menu");
			const $parsedListElem = $(draftLinkHtml);
			const draftHref = $parsedListElem.find("a").attr("href");
			// pp.log("appendOrReplaceIterationsDropdownItem -- articleId, parsedListElem, menu", articleId, $parsedListElem, $articleIterationsMenu);
			const menuContainsEditLinks =
				$articleIterationsMenu.length &&
				$articleIterationsMenu.find("a").length &&
				// @ts-expect-error
				$articleIterationsMenu.find("a").attr("href").indexOf("/edit") != -1;

			if (
				// @ts-expect-error
				(menuContainsEditLinks && draftHref.indexOf("/edit") == -1) ||
				// @ts-expect-error
				(!menuContainsEditLinks && draftHref.indexOf("/edit") != -1)
			) {
				// pp.log("mismatch");
				return;
			}

			// Always replace the link the Articles' menu so that it now links to the latest Draft
			$(".j-group-workspace-articles-menu")
				.find(`li[data-article-id='${articleId}']`)
				.find("a")
				// @ts-expect-error
				.attr("href", draftHref);

			if (!$articleIterationsMenu.length) {
				return;
			}

			$listElement = $articleIterationsMenu
				.find(`a[href='${draftHref}']`)
				.parent(); // the parent should be the `<li>` element

			if ($listElement.length) {
				if ($listElement.hasClass("active")) {
					$parsedListElem.addClass("active");
				}
				$listElement.replaceWith($parsedListElem);
			} else {
				if (!$articleIterationsMenu.children().length) {
					$parsedListElem.addClass("active"); // Mark list element as active so that `reloadActiveDraft` will show it immediately
				}
				$articleIterationsMenu.append($parsedListElem);
			}

			// For the menu being rendered from `_voteable_measures`: Determine whether to show it at all.
			// It's hidden by default until the first Draft is submitted, but should be hidden again if only unsubmitted Drafts exist (i.e. if Drafts has been annulled)
			if (
				$articleIterationsMenu
					.parent()
					.hasClass("j-article-iterations-menu-for-measures")
			) {
				if ($parsedListElem.hasClass("Draft--nav--state-unsubmitted")) {
					$parsedListElem.addClass("hidden");
				}
				if (
					$articleIterationsMenu.children(
						":not(.Draft--nav--state-unsubmitted)",
					).length
				) {
					$articleIterationsMenu.parent().removeClass("hidden");
				} else {
					$articleIterationsMenu.parent().addClass("hidden");
				}
			}
			return $parsedListElem;
		},

		prependOrReplaceIterationsInlineItem: (
			draftId,
			articleId,
			draftLinkHtml,
		) => {
			let $presentLink = $(`.Draft--nav a[data-target='#draft-${draftId}']`);

			if ($presentLink.length) {
				const wasAlreadyLoaded = $presentLink.attr("data-remote") !== undefined;
				const wasActive = $presentLink.parent().hasClass("active");
				$presentLink.parent().replaceWith(draftLinkHtml);
				// Load item again
				$presentLink = $(`.Draft--nav a[data-target='#draft-${draftId}']`);
				if (wasAlreadyLoaded) {
					$presentLink.attr("href", "javascript:;").removeAttr("data-remote");
				}
				if (wasActive) {
					$presentLink.parent().addClass("active");
				}
			} else {
				$(`#article-${articleId}`)
					.find("ul.Nav.Nav--tabs")
					.prepend(draftLinkHtml);
				// Build tab pane too
				$(`#article-${articleId}`).find("div.tab-content").append(
					// @ts-expect-error
					`<div id='draft-${draftId}' class='tab-pane fade'>${pp.loaderHtml}</div>`,
				);
			}
		},

		appendToSubmittedDraftsListing: (articleId, panelHtml) => {
			const $proposalPanel = $(
				`#collapse-sub-art-${articleId} > div.panel-body`,
			);
			if (!$proposalPanel.length) {
				return [];
			}

			$proposalPanel.find("span.j-unsubmitted-placeholder").remove();
			$proposalPanel.find("h4.hidden").removeClass("hidden"); // Unhide the headline for the first iteration if present
			$proposalPanel.append(panelHtml);
			pp.global.initSelect2For($proposalPanel.find("select"));

			const $proposalPanelIndicator = $(
				`a[href='#collapse-sub-art-${articleId}'] .j-unread-activities-indicator, .j-dropdown-link[data-article-id=${articleId}] .j-unread-activities-indicator`,
			);
			if ($proposalPanelIndicator.hasClass("j-submitted-drafts-size")) {
				let oldCount = parseInt($proposalPanelIndicator.text(), 10);
				if (isNaN(oldCount)) oldCount = 0;
				$proposalPanelIndicator.text(oldCount + 1);
			} else if ($proposalPanelIndicator.hasClass("j-checkmark-placeholder")) {
				$proposalPanelIndicator.attr(
					"class",
					"senaryon-icon senaryon-icon-check",
				);
			}
		},
	},

	publications: {
		insertOrUpdateFeedActivity: (
			publicationId,
			publishedAt,
			publicationCategory,
			feedItemHtml,
		) => {
			const $publicationsIndex = $(
				`.PublicationsIndex--${publicationCategory}`,
			);
			// pp.log("into insertOrUpdateFeedActivity -- Publication id, category, index elem", publicationId, publicationCategory, $publicationsIndex);
			if (!$publicationsIndex.length) {
				return;
			}

			var $existingPub = $publicationsIndex.find(
				`[data-publication-id='${publicationId}']`,
			);
			// pp.log("exists?", publicationId, $existingPub, publishedAt);

			if ($existingPub.length) {
				// If this feed is just updating the Publication feed item so that the view count will be incremented,
				// then the unread Activity ids will be lost because the `skip_own_evaluation` local will be false`
				var unreadActivityIds = pp.activities.arrayIfyActivityIds(
					$existingPub
						.find("span.j-pub-views-count")
						.attr("data-unread-activity-ids"),
				);
				pp.global.securelyReplaceDOMElemContent(
					$existingPub,
					$(feedItemHtml).html(),
				);
				$existingPub
					.find("span.j-pub-views-count")
					.attr("data-unread-activity-ids", unreadActivityIds);
				// trigger timeago setting and truncation manually, securelyReplaceDOMElemContent will not do this
				pp.publications[publicationCategory].$feed.trigger(
					"insertNode",
					$existingPub,
					"manualTrigger",
				);
				return false;
			}
			// else
			const insertBeforeTarget = $publicationsIndex
				.find("[data-publication-id]")
				.filter((index, pubElem) => {
					return $(pubElem).data("published-at") < publishedAt;
				})[0];
			if (insertBeforeTarget !== undefined) {
				$(insertBeforeTarget).before(feedItemHtml);
			} else if ($publicationsIndex.find(".pagination").length) {
				// Assume that the to-be-inserted Publication is *older* than all existing Publications
				$publicationsIndex.find(".pagination").before(feedItemHtml);
			} else {
				$publicationsIndex.prepend(feedItemHtml);
			}
			return $publicationsIndex.is(":visible");
		},

		removeFeedActivity: (publicationId) => {
			$(`.PublicationsIndex [data-publication-id=${publicationId}]`).remove();
			$(`.LiveNewsFeed__inner [data-publication-id=${publicationId}]`).remove();
		},

		appendOrReplaceMenuItem: (publicationLinkHtml) => {
			let $listElement;
			const $publicationsMenu =
				$(`.j-publications-menu`).find("ul.dropdown-menu");
			const $parsedListElem = $(publicationLinkHtml);
			// @ts-expect-error
			const publicationHref = $parsedListElem
				.find("a")
				.attr("href")
				.split("?")[0];

			$listElement = $publicationsMenu
				.find(`a[href='${publicationHref}']`)
				.parent(); // the parent should be the `<li>` element

			if ($listElement.length) {
				if ($listElement.hasClass("active")) {
					$parsedListElem.addClass("active");
				}
				$listElement.replaceWith($parsedListElem);
			} else {
				$publicationsMenu.append($parsedListElem);
			}
			return $parsedListElem;
		},

		/**
		 * make the Publication reload for whoever is still editing it right now or reset the form if it's kwitter.
		 */
		reloadActivePublication: (publicationPath) => {
			// pp.log("PAD show new state, or reset form for kwitter", publicationPath);
			// NB Always load the Publication, even if it is not really marked as 'active', if the menu is hidden.
			const $publicationLinkTarget = $(`a[href='${publicationPath}']`);
			if (
				!$publicationLinkTarget.length ||
				!$publicationLinkTarget.parent().hasClass("active")
			) {
				return;
			}
			$publicationLinkTarget.trigger("click");
		},
	},
};
